import { render, staticRenderFns } from "./temp-adjust-coordinate.vue?vue&type=template&id=4d348f5e&scoped=true"
import script from "./temp-adjust-coordinate.vue?vue&type=script&lang=js"
export * from "./temp-adjust-coordinate.vue?vue&type=script&lang=js"
import style0 from "./temp-adjust-coordinate.vue?vue&type=style&index=0&id=4d348f5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d348f5e",
  null
  
)

export default component.exports